import { Instance } from 'mobx-state-tree';
import { RouteTimelineEventDtoModelBase } from './RouteTimelineEventDtoModel.base';

/* The TypeScript type of an instance of RouteTimelineEventDtoModel */
export interface RouteTimelineEventDtoModelType extends Instance<typeof RouteTimelineEventDtoModel.Type> {}

/* A graphql query fragment builders for RouteTimelineEventDtoModel */
export { selectFromRouteTimelineEventDto, routeTimelineEventDtoModelPrimitives, RouteTimelineEventDtoModelSelector } from './RouteTimelineEventDtoModel.base';

/**
 * RouteTimelineEventDtoModel
 */
export const RouteTimelineEventDtoModel = RouteTimelineEventDtoModelBase;
